@if(visible) {
<div class="toast" [ngClass]="[bgColor, textColor]">
  <strong class="block text-lg">{{ title }}</strong>
  <p>{{ message }}</p>
</div>
}
